const NS = 'SidebarWidget';
const CLS = 'sidebarWidget';

export class SidebarWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);

		let profileDropdown = this.$element.find('.siteHeaderProfileDropdownWidget');
		let footer = $(document).find('.siteFooterWidget');

		profileDropdown.css({
			// (-1) adjustment for the default applied box-shadow
			'min-height': $(document).height() - footer.outerHeight() - 1
		});
	}
}
